import React from 'react'
import PropTypes from 'prop-types'
import TweetField from 'pages/widgets/form/tweet-input'
import PromotedOnlyCheckboxField from 'pages/widgets/form/promoted-only-checkbox/'
import UploadMosaicButton from './components/upload-mosaic-button'
import { Field } from 'redux-form'
import RangeSlider from '../../../../../../../../components/form/range-slider'
import Toggle from '../../../../../../../../components/form/toggle'

export class Mosaic extends React.Component {
  constructor (props) {
    super(props)

    this.formatValue = this.formatValue.bind(this)
  }

  // This is seperated to facilitate testing
  formatValue (value) {
    return value || []
  }
  render () {
    return (
      <div className='row'>
        <div className='br-has-checkbox col-sm-12'>
          <TweetField
            messageName={`${this.props.name}.message`}
            urlName={`${this.props.name}.attachmentUrl`}
            cardUriName={`${this.props.name}.cardUri`}
          />
          <PromotedOnlyCheckboxField name={this.props.name} />
        </div>
        <div className='col-sm-12'>
          <Field
            component={UploadMosaicButton}
            name={'mosaic.mediaId'}
            format={this.formatValue}
            mediaId={this.props.mediaId}
          />

          <p style={{ fontWeight: 600, color: '#6F6F6F', marginTop: 45 }}>
            Image duplication
          </p>
        </div>
        <div className='col-xs-2' style={{ marginTop: 18 }}>
          <Field
            component={Toggle}
            name={'mosaic.duplicatesAllowed'}
            value={this.props.duplicatesAllowed}
            checked={this.props.duplicatesAllowed || false}
          />
        </div>

        {this.props.duplicatesAllowed && (
          <div
            className='col-xs-10'
            style={{ marginTop: 0, marginBottom: 0, color: '#6F6F6F' }}
          >
            <Field
              name={'mosaic.duplication'}
              component={RangeSlider}
              min={5}
              max={55}
              step={5}
              grid_snap
              grid
              postfix='x duplication value'
              type='single'
              normalize={value => Number(value)}
            />
          </div>
        )}
      </div>
    )
  }
}

Mosaic.propTypes = {
  name: PropTypes.string,
  mediaId: PropTypes.array,
  duplicatesAllowed: PropTypes.bool
}

export default Mosaic



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/add-to-mosaic/mosaic/index.js